module.exports = __webpack_public_path__ + "th.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/flag-icon-css/flags/4x3/th.svg
// module id = 837
// module chunks = 0